import React from "react";

import { ResponseType, OptionsType } from "commons/types/http";

import useHttpManaged from "hooks/useHttpManaged";

import { PathParamsWithId } from "commons/types/api/common";

import {
    SectionOneImageTextBody,
    SectionOneImageTextDetails,
} from "types/api/blocks/sectionOneImageText";

function useSectionOneImageTextApi() {
    const { get, del, post } = useHttpManaged();
    const getOneSectionOneImageText = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<SectionOneImageTextDetails> => {
        return get<PathParamsWithId, undefined, SectionOneImageTextDetails>({
            url: "/blocks/section-one-image-text/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [get]);
    const saveSectionOneImageText = React.useCallback((body: SectionOneImageTextBody, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return post<undefined, undefined, SectionOneImageTextBody, null>({
            url: "/blocks/section-one-image-text",
            body: body,
            options: options,
            headers: headers
        });
    }, [post]);
    const deleteSectionOneImageText = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return del<PathParamsWithId, undefined, null>({
            url: "/blocks/section-one-image-text/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [del]);
    return {
        getOneSectionOneImageText,
        saveSectionOneImageText,
        deleteSectionOneImageText
    };
}

export default useSectionOneImageTextApi;